<template>
    <div>
        <v-dialog v-model="mostrar" persistent max-width="400">
            <v-card>
                <v-card-title class="headline">Nuevo puesto</v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="nombre"
                        :error-messages="nombreErrors"
                        label="Nombre"
                        required
                        @input="$v.nombre.$touch()"
                        @blur="$v.nombre.$touch()"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="$emit('cancelarAgregar')">Cancelar</v-btn>
                <v-btn color="blue" dark @click="guardar()">Agregar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment'

import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'AgregarPuestos',
    props:['mostrar'],
    mixins: [validationMixin],
    computed: {
      ...mapGetters([
          "sessionToken",
          "httpURL",
          "userId",
          "permisos",
          "role"
      ]),
      nombreErrors () {
        const errors = []
        if (!this.$v.nombre.$dirty) return errors
        !this.$v.nombre.minLength && errors.push('Mínimo 5 caracteres.')
        !this.$v.nombre.required && errors.push('Campo requerido.')
        return errors
      }
    },
    validations: {
      nombre: { required, minLength: minLength(5) }
    },
    data() {
        return {
            enviando:false,
            nombre: null            
        }
    },
    methods:{
      guardar(){
        this.$v.$touch();
        if( !this.$v.$invalid ){
          this.$emit('enviandoStart');
          axios.post(this.httpURL+'/puestos/agregar',
            { nombre: this.nombre},
            {headers:{token: this.sessionToken}})
            .then(res => {
                this.nombre = null;
                this.$emit('enviandoStop');
                this.$v.$reset();
                this.$emit('puestoAgregado',res.data.puesto);
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.$emit('enviandoStop');
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        }
      }
    }
    
}
</script>